<template>
    <div class="resource-documents uk-container uk-container-expand">
        <div class="">
            <h1 class="uk-heading-primary uk-align-left">Your Files</h1>
            <div class="uk-heading-primary uk-align-left uk-margin-large-left">
                <label v-if="allowUpload" class="upload-files" >
                    <input type="file" multiple @change="uploadFile($event)" />
                    <i class="fas fa-plus-circle"></i> Upload Files
                </label>
            </div>
            <div class="uk-clearfix"></div>
            <div class="uk-align-right uk-margin-remove-bottom">
                <div class="uk-grid">
                    <div class="uk-form-controls">
                        <button class="uk-button uk-button-secondary" type="button">Filter <i class="fas fa-filter"></i></button>
                        <div uk-dropdown>
                            <ul class="uk-nav uk-dropdown-nav">
                                <li v-for="tag in allTags">
                                    <label><input class="uk-checkbox" type="checkbox" @click="toggleFilterTag(tag)"> {{ tag.name }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="uk-form-controls">
                        <input class="uk-input" placeholder="Enter search terms..." v-model="searchTerm" />
                    </div>
                    <div class="uk-form-controls">
                        <label for="file-filter" class="">Sort By</label>
                        <select id="file-filter" class="uk-select uk-width-auto" v-model="sortBy" @change="sortDocuments">
                            <option v-for="option in sortOptions" :value="option.type">{{ option.name }}</option>
                        </select>
                    </div>
                    <span class="download-selected" v-if="selectedDocuments.length == 0" >
                        Download Selected <i class="fas fa-download"></i>
                    </span>
                    <a class="download-selected ready" v-if="selectedDocuments.length > 0" :href="zipLink" target="_blank" >
                         Download Selected <i class="fas fa-download"></i>
                    </a>
                </div>
            </div>
            <div class="uk-clearfix"></div>
            <div v-if="documents.length == 0" >
                No files available.
            </div>
            <div class="resource-documents-list">
                <!-- SELECTED DOCUMENTS -->
                <div class="resource-documents-list-group">
                    <div class="resource-documents-list-group-header" :class="{'empty':selectedDocuments.length == 0}">Selected Files</div>
                    <transition-group name="expand" @enter="enter"
                                      @after-enter="afterEnter"
                                      @leave="leave">
                        <div v-for="document in selectedDocuments" :key="'doc_'+document.id" class="resource-documents-list-group-item selected uk-grid">
                            <div class="uk-width-1-2@m uk-grid">
                                <div>
                                    <label>
                                        <input class="uk-checkbox" type="checkbox" @click="toggleItem($event, document.id)" checked />
                                        <span>
                                        <i class="file-icon fas" :class="fileIconClass(document.type)"></i>
                                    </span>
                                    </label>
                                </div>
                                <div>
                                    <div>
                                        {{ document.name }}

                                        <span class="control-icons">
                                            <i class="fas fa-tag" uk-toggle="#tag-modal" @click="setTagsFor(document.id)"></i>
                                            <a :href="'/resources/view/'+document.id+'/' + document.name" target="_blank">
                                                <i class="fas fa-search"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <div class="by-line">
                                        Uploaded by {{ document.user.name }} - {{ fromNow(document.created_at) }}
                                        - {{ humanFileSize(document.size) }}
                                    </div>
                                </div>
                            </div>
                            <div class="uk-width-1-2@m uk-grid uk-margin-remove-top">
                                <div class="uk-width-2-3">
                                    <span class="tag" v-for="tag in document.tags">{{ tag.name }}</span>
                                </div>
                                <div class="uk-width-1-3">
                                    <a :href="'/resources/download/'+document.id+'/' + document.name" target="_blank">
                                        <i class="fas fa-download"></i> Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </div>

                <!-- ALL DOCUMENTS -->
                <div class="resource-documents-list-group" v-for="(documentGroup, name) in sortedDocuments">
                    <div class="resource-documents-list-group-header">{{name}}</div>
                    <transition-group name="expand" @enter="enter"
                                      @after-enter="afterEnter"
                                      @leave="leave">
                        <div v-for="document in documentGroup.documents" :key="'doc_'+document.id" class="resource-documents-list-group-item uk-grid">
                            <div class="uk-width-1-2@m uk-grid">
                                <div>
                                    <label>
                                        <input class="uk-checkbox" type="checkbox" @click="toggleItem($event, document.id)" />
                                        <span>
                                            <i class="file-icon fas" :class="fileIconClass(document.type)"></i>
                                        </span>
                                    </label>
                                </div>
                                <div>
                                    <div>
                                        {{ document.name }}
                                        <span class="control-icons">
                                            <i class="fas fa-tag" uk-toggle="#tag-modal" @click="setTagsFor(document.id)"></i>
                                            <a :href="'/resources/view/'+document.id+'/' + document.name" target="_blank">
                                                <i class="fas fa-search"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <div class="by-line">
                                        Uploaded by {{ document.user.name }} - {{ fromNow(document.created_at) }}
                                        - {{ humanFileSize(document.size) }}
                                    </div>
                                </div>
                            </div>
                            <div class="uk-width-1-2@m uk-grid uk-margin-remove-top">
                                <div class="uk-width-2-3">
                                    <span class="tag" v-for="tag in document.tags">{{ tag.name }}</span>
                                </div>
                                <div class="uk-width-1-3">
                                    <a :href="'/resources/download/'+document.id+'/' + document.name" target="_blank">
                                        <i class="fas fa-download"></i> Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </div>
            </div>
        </div>
        <!-- Tag editor pop-up -->
        <div id="tag-modal" uk-modal class="resource-documents">
            <div class="uk-modal-dialog uk-modal-body">
                <div v-if="taggingDocument">
                    <h2 class="uk-modal-title uk-margin-medium-bottom">{{ taggingDocument.name }}</h2>
                    <div class="uk-grid uk-grid-small">
                        <div>
                            <input class="uk-input" v-model="tagName" @keyup="checkEnter($event)" />
                        </div>
                        <div>
                            <button class="uk-button uk-button-primary" @click="addTag">Add Tag</button>
                        </div>
                    </div>
                    <div class="tag-cloud">
                        <span v-for="(tag, i) in tagNames" class="tag">
                            {{ tag }}
                            <i class="fas fa-times" @click="removeTag(i)"></i>
                        </span>
                    </div>
                </div>
                <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitTags()">Done</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Moment from "moment";
    export default {
        name: "ResourceDocuments",

        props: {
            allowUpload:{
                type: Boolean,
                default: false
            }
        },

        data(){
            return {
                documents:[],
                selectedDocuments:[],
                sortedDocuments:{},
                sortOptions:[
                    {
                        type:"alpha",
                        name:"Alphabetical"
                    },
                    {
                        type:"date",
                        name:"Date"
                    },
                    {
                        type:"type",
                        name:"Type"
                    },
                ],
                sortBy:"date",
                searchTerm:"",
                typeCount:0,
                zipLink:"",
                taggingDocument:null,
                tagName:"",
                tagNames:[],
                allTags:[],
                filterTags:[]
            };
        },

        mounted(){
            this.loadFiles();

            axios.get("/api/resources/tags")
                .then((pack) => this.updateAllTags(pack));
        },

        methods:{
            loadFiles(){
                let searchPath = "/api/resources?q=" + this.searchTerm;
                if(this.filterTags.length > 0){
                    let tagIds = [];
                    for(let i = 0; i < this.filterTags.length;++i){
                        tagIds.push(this.filterTags[i].id);
                    }

                    searchPath += "&tags=" + tagIds.join(",");
                }
                axios.get(searchPath)
                    .then((pack) => this.updateList(pack));
            },
            updateList(pack){
                let newDocs = pack.data.data;
                for(let i = 0; i < newDocs.length;++i){
                    for(let j = 0; j < this.selectedDocuments.length;++j){
                        if(newDocs[i].id == this.selectedDocuments[j].id){
                            this.selectedDocuments[j] = newDocs[i];
                            newDocs.splice(i, 1);
                            --i;
                            break;
                        }
                    }
                }
                this.documents = newDocs;
                this.sortDocuments();
            },
            updateAllTags(pack){
                if(pack.data.success){
                    this.allTags = pack.data.data;
                }
            },
            startSearch(){
                this.loadFiles();
            },
            apiSearch(){
                this.typeCount--;
                if(this.typeCount <= 0){
                    this.startSearch();
                }
            },
            uploadFile(event){
                let formData = new FormData();

                for(let i = 0; i < event.target.files.length;++i){
                    formData.append("file" + i, event.target.files[i]);
                }

                axios.post("/api/resources/upload", formData)
                    .then(() => this.loadFiles());
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            },
            toggleItem(e, id){
                if(e.target.checked){
                    for(let i = 0; i < this.documents.length;++i){
                        if(this.documents[i].id == id){
                            this.selectedDocuments.push(this.documents[i]);
                            this.documents.splice(i, 1);
                            break;
                        }
                    }
                } else {
                    for(let i = 0; i < this.selectedDocuments.length;++i){
                        if(this.selectedDocuments[i].id == id){
                            this.documents.push(this.selectedDocuments[i]);
                            this.selectedDocuments.splice(i, 1);
                            break;
                        }
                    }
                }
                this.setZipLink();
                this.sortDocuments();
            },
            setZipLink(){
                if(this.selectedDocuments.length == 0){
                    this.zipLink = "";
                } else {
                    let fileIds = [];
                    for(let i = 0; i < this.selectedDocuments.length;++i){
                        fileIds.push(this.selectedDocuments[i].id);
                    }

                    this.zipLink = "/resources/zip?list=" + fileIds.join(",");
                }
            },
            sortDocuments(){
                this.sortedDocuments = {};
                switch(this.sortBy){
                    case "alpha":
                        this.documents.sort(this.alphabetComparison);
                        for(let i = 0; i < this.documents.length;++i) {
                            let doc = this.documents[i];
                            let name = doc.name.substr(0,1).toUpperCase();
                            this.addToSortedDocuments(name, doc);
                        }
                        break;
                    case "date":
                        this.documents.sort(this.dateComparison);
                        for(let i = 0; i < this.documents.length;++i){
                            let doc = this.documents[i];
                            let date = new Moment(doc.created_at);
                            let name = date.format("MMMM Do YYYY");
                            this.addToSortedDocuments(name, doc);
                        }
                        break;
                    case "type":
                        this.documents.sort(this.typeComparison);
                        for(let i = 0; i < this.documents.length;++i){
                            let doc = this.documents[i];
                            let name = doc.type;
                            this.addToSortedDocuments(name, doc);
                        }
                        break;
                }

                Object.keys(this.sortedDocuments).forEach((name) => this.alphabetize(name));
            },
            addToSortedDocuments(name, doc){
                if(!this.sortedDocuments.hasOwnProperty(name)){
                    this.sortedDocuments[name] = {
                        name:name,
                        documents:[]
                    }
                }

                this.sortedDocuments[name].documents.push(doc);
            },
            alphabetize(name){
                this.sortedDocuments[name].documents.sort(this.alphabetComparison);
            },
            alphabetComparison(a, b){
                let name1 = a.name.toUpperCase();
                let name2 = b.name.toUpperCase();

                return name1.localeCompare(name2);
            },
            typeComparison(a, b){
                let name1 = a.type.toUpperCase();
                let name2 = b.type.toUpperCase();

                return name1.localeCompare(name2);
            },
            dateComparison(a, b){
                let time1 = new Moment(a.created_at);
                let time2 = new Moment(b.created_at);

                if(time1.isBefore(time2, "day")){
                    return 1;
                }

                return -1;
            },
            fileIconClass(type){
                switch(type){
                    case "tar":
                    case "gz":
                    case "zip":
                        return "fa-file-archive";
                    case "wav":
                    case "mp3":
                    case "aiff":
                    case "wma":
                    case "au":
                    case "m4a":
                    case "flac":
                    case "ogg":
                        return "fa-file-audio";
                    case "png":
                    case "jpg":
                    case "jpeg":
                    case "gif":
                    case "bmp":
                        return "fa-file-image";
                    case "mp4":
                    case "m4v":
                    case "wmv":
                    case "flv":
                    case "mov":
                        return "fa-file-video";
                    case "doc":
                    case "docx":
                    case "docm":
                        return "fa-file-word";
                    case "xls":
                    case "xlsx":
                    case "xlsm":
                        return "fa-file-excel";
                    case "ppsx":
                    case "ppt":
                    case "pps":
                    case "pot":
                    case "pptm":
                    case "pptx":
                        return "fa-file-powerpoint";
                    case "pdf":
                        return "fa-file-pdf";
                    default:
                        return "fa-file"
                }
            },
            fromNow(date){
                let m = new Moment(date);

                return m.utc().fromNow();
            },
            humanFileSize(bytes, si = true) {
                var thresh = si ? 1000 : 1024;
                if(Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }
                var units = si
                    ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
                    : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
                var u = -1;
                do {
                    bytes /= thresh;
                    ++u;
                } while(Math.abs(bytes) >= thresh && u < units.length - 1);
                return bytes.toFixed(1)+' '+units[u];
            },
            setTagsFor(id){
                let foundIt = false;

                for(let i = 0; i < this.documents.length;++i){
                    if(this.documents[i].id == id) {
                        this.taggingDocument = this.documents[i];
                        foundIt = true;
                        break;
                    }
                }

                if(!foundIt){
                    for(let i = 0; i < this.selectedDocuments.length;++i){
                        if(this.selectedDocuments[i].id == id) {
                            this.taggingDocument = this.selectedDocuments[i];
                            foundIt = true;
                            break;
                        }
                    }
                }

                if(foundIt){
                    this.tagNames = [];
                    for(let i = 0; i < this.taggingDocument.tags.length;++i){
                        this.tagNames.push(this.taggingDocument.tags[i].name);
                    }
                }
            },
            addTag(){
                this.tagNames.push(this.tagName);
                this.tagName = "";
            },
            removeTag(i){
                this.tagNames.splice(i, 1);
            },
            submitTags(){
                axios.post("/api/resources/tags/set/" + this.taggingDocument.id, {
                    tags:this.tagNames
                }).then(
                    () => this.startSearch(),
                    () => this.startSearch()
                );
            },
            cancelTagging(){
                this.taggingDocument = null;
            },
            checkEnter(e){
                if(e.key == "Enter" || e.keyCode == 13){
                    this.addTag();
                }
            },
            addFilterTag(tag){
                this.filterTags.push(tag);
            },
            removeFilterTag(tag){
                let found = false;
                for(let i = 0; i < this.filterTags.length;++i){
                    if(this.filterTags[i].id == tag.id){
                        this.filterTags.splice(i, 1);
                        i--;
                        found = true;
                    }
                }

                return found;
            },
            toggleFilterTag(tag){
                console.log(tag);
                if(!this.removeFilterTag(tag)){
                    this.addFilterTag(tag);
                }
            },
            enter(element) {
                const width = getComputedStyle(element).width;

                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;

                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;
                getComputedStyle(element).height;
                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
            leave(element) {
                const height = getComputedStyle(element).height;

                element.style.height = height;
                getComputedStyle(element).height;

                setTimeout(() => {
                    element.style.height = 0;
                });
            },
        },
        watch:{
            searchTerm() {
                this.typeCount++;
                setTimeout(() => this.apiSearch(), 400);
            },
            filterTags(){
                this.typeCount++;
                setTimeout(() => this.apiSearch(), 400);
            }

        }
    }
</script>
